var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Have you received your Mortgage Commitment?"}},[_c('div',{staticClass:"flex flex-col sm:flex-row flex-1 sm:items-center"},[_c('input-radio-multi',{attrs:{"name":"has_received_mortgage_commitment","value":_vm.mortgage.has_received_mortgage_commitment,"options":[
                { label: 'Yes', value: 1, },
                { label: 'No', value: 0, },
                { label: 'N/A', value: -1, },
            ],"read_only":_vm.read_only}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }